import { secureFetch } from './authService';
import {API_BASE_URL, PAGINATION_DEFAULT_LIMIT} from './constants';

export function getAttributes(query) {
	let url = API_BASE_URL + '/apps/attributes';
	if (query) {
		url = API_BASE_URL + `/apps/attributes?limit=${query.limit || PAGINATION_DEFAULT_LIMIT}&page=${query.page || 0}`;
	}
	return secureFetch(url, {
		method: 'GET'
	});
	//return Promise.resolve({"data":[{"id":1,"name":"versionCode","type":"APK","valueType":"STRING","defaultValue":"","permittedValues":[],"xpathMapping":"string(.//manifest/@versionCode)"},{"id":3,"name":"targetSdkVersion","type":"APK","valueType":"STRING","defaultValue":"","permittedValues":[],"xpathMapping":"string(.//manifest/uses-sdk/@targetSdkVersion)"},{"id":2,"name":"minSdkVersion","type":"APK","valueType":"STRING","defaultValue":"","permittedValues":[],"xpathMapping":"string(.//manifest/uses-sdk/@minSdkVersion)"},{"id":100,"name":"testAttr","type":"APK","valueType":"STRING","defaultValue":"","permittedValues":["val_1","val_2","val_3"],"xpathMapping":""}]})
}

export function addAttribute(attribute) {
	return secureFetch(API_BASE_URL + '/apps/attributes', {
		method: 'POST',
		body: JSON.stringify(attribute)
	});
}

export function updateAttribute(attribute) {
	return secureFetch(API_BASE_URL + '/apps/attributes/' + attribute.id, {
		method: 'PUT',
		body: JSON.stringify(attribute)
	});
}

export function updateCompanyAttributesList(attributes) {
	return secureFetch(API_BASE_URL + '/company/attributes', {
		method: 'PUT',
		body: JSON.stringify(attributes)
	});
}

export function deleteAttribute(attributeId) {
	return secureFetch(API_BASE_URL + '/apps/attributes/' + attributeId, {
		method: 'DELETE'
	});
}

export function updateAppAttributesList(attributes) {
	return secureFetch(API_BASE_URL + '/apps/mobileapps/attributes', {
		method: 'PUT',
		body: JSON.stringify(attributes)
	});
}

export function updateApkAttributesList(attributes) {
	return secureFetch(API_BASE_URL + '/apps/apks/attributes', {
		method: 'PUT',
		body: JSON.stringify(attributes)
	});
}

export function updateStoreAttributesList(attributes) {
	return secureFetch(API_BASE_URL + '/retail/salesPoints/attributes', {
		method: 'PUT',
		body: JSON.stringify(attributes)
	});
}

export function updatePocketAttributesList(attributes) {
	return secureFetch(API_BASE_URL + '/retail/bundles/attributes', {
		method: 'PUT',
		body: JSON.stringify(attributes)
	});
}

export function updateUserAttributesList(attributes) {
	return secureFetch(API_BASE_URL + '/users/attributes', {
		method: 'PUT',
		body: JSON.stringify(attributes)
	});
}



// WEBPACK FOOTER //
// ./src/helpers/attributesService.js